import React, {useState, useEffect, useRef} from 'react';
import Axios from 'axios';
import {Surface3} from '../Surface3';
import { FaRegWindowClose, FaEdit, FaWindowClose} from 'react-icons/fa';
import PropTypes from 'prop-types';
import {Citation} from '../Citation/Citation';
import {textClean} from 'ngram-diff'
import { Tooltip } from 'react-tooltip';
import { ToolTipContent } from '../ToolTipContent/ToolTipContent';

import * as CollationTableTypes from './CollationTableTypes';
//import { propTypes } from 'react-bootstrap/esm/Image';

import "./CollationTable.scss"
import { withTheme } from '@storybook/core/theming';


interface MyComponentProps {
  expressionIds: string[]
  expressionid?: string
  manifestationid?: string
  handleSetVariantIndexList?: (variantIndexList: any) => void
  handleOnSegDoubleClick?: any
  handleOnSegClick?: any
  
}

export const CollationTable: React.FC<MyComponentProps> = (props) => {


  //const [expressionId, setExpressionId] = useState()
  //const [expressionWordRange, setExpressionWordRange] = useState()
  const [collateXData, setCollateXData] = useState()
  const [focusImage, setFocusImage] = useState(undefined)
  const [imageCoordinates, setImageCoordinates] = useState<any | null>()
  const [imagesFound, setImagesFound] = useState(true)
  const [citationInfo, setCitationInfo] = useState<CollationTableTypes.CitationSelectionObject>()
  const [rawTexts, setRawTexts] = useState<any>({}) // using this to preserve raw text for lookup purposes
  // const [variantIndexList, setVariantIndexList] = useState()
  const [displayObjectsArrayList, setDisplayObjectsArrayList] = useState([])
  const [excludeList, setExcludeList] = useState([]) // e.g. "/vat/transcription"
  const [witTitles, setWitTitles] = useState({})
  
  const prevExpressionIdsRef = useRef<string[] | undefined>(undefined);
  
    const expressionIdsArray: string[] = []
    
    const expressionIdsWordRangeMap: { [key: string]: string } = {};
    props?.expressionIds.forEach((e) => {
      const id = e.split("@")[0]
      const wordRange = e.split("@")[1]
      expressionIdsArray.push(id)
      expressionIdsWordRangeMap[id] = wordRange
    })
  

  /***
   * @description: function to check if arrays are the same:
   * used in useEffect to prevent fetch if arrays values are the same
   */
  const arraysEqual = (a, b) => {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;

    for (let i = 0; i < a.length; ++i) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  };

  useEffect(()=> {
    //clear excludeList when expressionid changes
    setExcludeList([])
  }, [props.expressionid])

  useEffect(()=> {
    if (!arraysEqual(prevExpressionIdsRef.current, props.expressionIds)) {
      retrieveCollateX(props.expressionIds);
      prevExpressionIdsRef.current = props.expressionIds;
    }
  }, [props.expressionIds])

  useEffect(() => {
    retrieveCollateX(props.expressionIds);
  }, [excludeList])

  // create variant list when displayObjectsArrayList is updated
  useEffect(() => {
    createVariantIndexList()
  }, [displayObjectsArrayList])

  //conce collatex data is retrieved, create display objects
  useEffect(() => {
    createDisplayObjects()
  },[collateXData])
  /**
   * 
   * @param {Array} expressionIds 
  */
  const retrieveCollateX = async(expressionIds: string[]) => {
    setDisplayObjectsArrayList([])
    props.handleSetVariantIndexList?.([])
    let results =  (await getTranscriptions(expressionIds)).data.results.bindings
    results = results.filter((r: any) => {
      // TODO clean up string matching here; we shouldn't need to do this much string splitting
      if (excludeList.every(str => !str.includes(r.block_transcription.value.split("/resource")[1]))){
        return r
      }
    })
    const topLevelShortId = await results[0].topLevelShortId ? results[0].topLevelShortId.value : "";
    const itemShortId = await results[0].topLevelShortId ? results[0].itemShortId.value : "";
    //const blockManTitle = await results[0].block_man_title ? results[0].block_man_title.value : "";
    const textsPromiseArray = results.map((r: any) => {
        return getCollation(r.blockid.value, r.block_transcription.value, topLevelShortId, itemShortId, r.block_man_title?.value)
    })
    
    
    const witnesses = await Promise.all(textsPromiseArray).then((values) => {
      const witnessArray: any = []
      const rawText: any = {}
      const witnessTitles: any = {}

      values.forEach((r: any, i: number) => {
        const entry =  r
        const eslug = entry.id.split("/resource/")[1].split("/")[0]
        const mslug = entry.id.split("/resource/")[1].split("/")[1]
        const mtitle = entry.block_man_title
        // conditional is added here to remove undefined values
        // because collatex request will fail if a witness is sent 
        // that does not have a text value
        if (entry.text.trim()){
          witnessArray.push({ "id": eslug + "/" + mslug, "content": entry.text.trim()})
          rawText[eslug + "/" + mslug] = entry.rawText.trim().split(" ")
          witnessTitles[eslug + "/" + mslug] = mtitle
        }
      })
      // .filter(entry => entry !== undefined) // filter added here to remove undefined values

      return {
        witnessArray,
        rawText,
        witnessTitles
      }
     })
     // creating a raw texts look up has, so that the original words before normalization 
     // can be accessed. This is used for example in handleSetCitationInfo 
    //  const rawTexts = await Promise.all(textsPromiseArray).then((values) => {
    //   const rawText: any = {}
      
    //   values.forEach((r: any, i) => {
    //     const entry: any =  r
    //     const eslug: string = entry.id.split("/resource/")[1].split("/")[0]
    //     const mslug: string = entry.id.split("/resource/")[1].split("/")[1]
    //     if (entry.rawText){
    //       rawText[eslug + "/" + mslug] = entry.rawText.trim().split(" ")
    //     }
    //   })
    //   return rawText
    // })
  const postObject = {
        "algorithm": "dekker",
        "joined": true,
        "tokenComparator": { "type": "equality" },
        "transpositions": true,
        "witnesses": witnesses.witnessArray
      }
      const url = "https://collatex.net/demo/collate"

      const postConfig = {
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
        },
      }
      
      const retrievedCollateXData = await Axios.post(url, postObject, postConfig)
      
      setCollateXData(retrievedCollateXData.data)
      setRawTexts(witnesses.rawText)
      setWitTitles(witnesses.witnessTitles)
      //createDisplayObjects(retrievedCollateXData.data)
    }
  /**
   * 
   * @param {Array} expressionIds 
  */
  const getTranscriptions = async (expressionIds: string[]) => {
    var ids = expressionIds.map((i) => {return "<" + i + ">"}).join(" ")
      var query = [
        "SELECT ?transcription ?block_transcription ?next ?previous ?shortId ?itemShortId ?topLevelShortId ?blockid ?block_man_title ",
        "WHERE",
        "{",
        "VALUES ?blockid {" + ids + "} . " ,
        "?blockid <http://scta.info/property/hasManifestation> ?block_manifestation .",
        "OPTIONAL{?block_manifestation <http://purl.org/dc/elements/1.1/title> ?block_man_title .}",
        //"?block_manifestation <http://scta.info/property/isManifestationOf> ?individualBlockId .",
        "?blockid <http://scta.info/property/shortId> ?shortId .",
        "?block_manifestation <http://scta.info/property/hasCanonicalTranscription> ?block_transcription .",
        "OPTIONAL",
        "{",
          "?blockid <http://scta.info/property/isPartOfStructureItem> ?structureItem .",
          "?structureItem <http://scta.info/property/shortId> ?itemShortId .",
          "?blockid <http://scta.info/property/isPartOfTopLevelExpression> ?topLevel .",
          "?topLevel <http://scta.info/property/shortId> ?topLevelShortId .",
        "}",
        "MINUS {",
          "?block_transcription <http://scta.info/property/transcriptionType> 'translation' .",
        "}",
        "OPTIONAL {",
        "?blockid <http://scta.info/property/next> ?next .",
        "}",
        "OPTIONAL {",
        "?blockid <http://scta.info/property/previous> ?previous .",
        "}",
        "}"].join('');
    
        const sparqlEndpoint = "https://sparql.scta.info/ds/query"
        
        const results = await Axios.get(sparqlEndpoint, { params: { "query": query, "output": "json" } })
        
        return results
  }
  const getCollation = async (expressionId: string, transcriptionId: string, topLevelShortId: string, itemShortId: string, block_man_title: string) => {
    
      const data  = await Axios.get("https://exist.scta.info/exist/apps/scta-app/csv-pct.xq?resourceid=" + transcriptionId)
      const dataObject = {
        "rawText": expressionIdsWordRangeMap[expressionId] ? textClean(textReduce(data.data, expressionIdsWordRangeMap[expressionId]),false) : textClean(data.data, false), 
        "text": expressionIdsWordRangeMap[expressionId] ? textClean(textReduce(data.data, expressionIdsWordRangeMap[expressionId])) : textClean(data.data),
        "id": transcriptionId,
        topLevelShortId,
        itemShortId,
        block_man_title
      }
    return dataObject
      
  }

  const textReduce = (text: string, wordRange: string) => {
      const wordTokenStart = wordRange.split("-")[0]
      const wordTokenEnd = wordRange.split("-")[1]
      const wordTokens = text.split(" ")
      // NOTE: I'm not sure what this .filter(Boolean) is doing??
      const wordTokensClean = wordTokens.filter(Boolean)
      //const wordTokensBefore = wordTokensClean.slice(0, wordTokenStart - 1);
      //const wordTokensAfter = wordTokensClean.slice(wordTokenEnd)
      const wordTokensFocus = wordTokensClean.slice(wordTokenStart - 1, wordTokenEnd)
      const reducedText = wordTokensFocus.join(" ")
      return reducedText
  }


  
  const handleSetCitationInfo = (s: CollationTableTypes.CitationSegment) => {
    let citationStart = s.segCountStart
    let citationEnd = s.segCountEnd
    
    // using Raw text here to get the raw version of the word to improve the
    // the xml look up within github. 
    // if using the normalized word, the github look up cannot find the word with the xml do
    const rawText = rawTexts[s.witness] 
    // using -1 here because citation word count starts at 1 instead of 0
    let citationWord = rawText[citationStart - 1]
    const citationSelectionObject: CollationTableTypes.CitationSelectionObject  = {
        
        tresourceid: "http://scta.info/resource/" + s.witness + "/transcription",
        selectionRange: {
          wordRange: {
            start: citationStart,
            end: citationEnd
          },
          text: citationWord,
        }
      }
      setCitationInfo(citationSelectionObject)
  }


  // This function was copied to ngram-diff library
  // TODO it would be better to use the library function so that there is one common function responsible for 
  // all text cleaning operations
  // const textClean = (text:string, replacements = true) => {

  //   //convert pilcrows to et
  //   let punctuationless = text.trim()

  //   punctuationless = text.replace(/&/g, "et");
  //   //convert remove punctuation
  //   const punctuationRegEx = /[!-/:-@[-`{-~¡-©«-¬®-±´¶-¸»¿×÷˂-˅˒-˟˥-˫˭˯-˿͵;΄-΅·϶҂՚-՟։-֊־׀׃׆׳-״؆-؏؛؞-؟٪-٭۔۩۽-۾܀-܍߶-߹।-॥॰৲-৳৺૱୰௳-௺౿ೱ-ೲ൹෴฿๏๚-๛༁-༗༚-༟༴༶༸༺-༽྅྾-࿅࿇-࿌࿎-࿔၊-၏႞-႟჻፠-፨᎐-᎙᙭-᙮᚛-᚜᛫-᛭᜵-᜶។-៖៘-៛᠀-᠊᥀᥄-᥅᧞-᧿᨞-᨟᭚-᭪᭴-᭼᰻-᰿᱾-᱿᾽᾿-῁῍-῏῝-῟῭-`´-῾\u2000-\u206e⁺-⁾₊-₎₠-₵℀-℁℃-℆℈-℉℔№-℘℞-℣℥℧℩℮℺-℻⅀-⅄⅊-⅍⅏←-⏧␀-␦⑀-⑊⒜-ⓩ─-⚝⚠-⚼⛀-⛃✁-✄✆-✉✌-✧✩-❋❍❏-❒❖❘-❞❡-❵➔➘-➯➱-➾⟀-⟊⟌⟐-⭌⭐-⭔⳥-⳪⳹-⳼⳾-⳿⸀-\u2e7e⺀-⺙⺛-⻳⼀-⿕⿰-⿻\u3000-〿゛-゜゠・㆐-㆑㆖-㆟㇀-㇣㈀-㈞㈪-㉃㉐㉠-㉿㊊-㊰㋀-㋾㌀-㏿䷀-䷿꒐-꓆꘍-꘏꙳꙾꜀-꜖꜠-꜡꞉-꞊꠨-꠫꡴-꡷꣎-꣏꤮-꤯꥟꩜-꩟﬩﴾-﴿﷼-﷽︐-︙︰-﹒﹔-﹦﹨-﹫！-／：-＠［-｀｛-･￠-￦￨-￮￼-�]|\ud800[\udd00-\udd02\udd37-\udd3f\udd79-\udd89\udd90-\udd9b\uddd0-\uddfc\udf9f\udfd0]|\ud802[\udd1f\udd3f\ude50-\ude58]|\ud809[\udc00-\udc7e]|\ud834[\udc00-\udcf5\udd00-\udd26\udd29-\udd64\udd6a-\udd6c\udd83-\udd84\udd8c-\udda9\uddae-\udddd\ude00-\ude41\ude45\udf00-\udf56]|\ud835[\udec1\udedb\udefb\udf15\udf35\udf4f\udf6f\udf89\udfa9\udfc3]|\ud83c[\udc00-\udc2b\udc30-\udc93]/g;
  //   punctuationless = punctuationless.replace(punctuationRegEx, '').replace(/(\s){2,}/g, '$1');
  //   //let punctuationless = text.replace(/[.,/#!$%^&*;:{}=\-_`~()/\u00B6/|/\u204B/]/g,"");
    
  //   // convert to lowercase
  //   punctuationless = punctuationless.toLowerCase()
    
  //   const replacementsSecund = {
  //     '1m': 'primum',
  //     '1um': 'primum',
  //     '1am': 'primam',
  //     '1ae': 'primae',
  //     '1a': 'prima',
  //     '1o': 'primo',
  //     '1us': 'primus',
  //     '2m': 'secundum',
  //     '2um': 'secundum',
  //     '2am': 'secundam',
  //     '2ae': 'secunde',
  //     '2a': 'secunda',
  //     '2o': 'secundo',
  //     '2us': 'secundus',
  //     '3m': 'tertium',
  //     '3um': 'tertium',
  //     '3am': 'tertiam',
  //     '3ae': 'tertiae',
  //     '3a': 'tertia',
  //     '3o': 'tertio',
  //     '3us': 'tertius',
  //     '4m': 'quartum',
  //     '4um': 'quartum',
  //     '4am': 'quartam',
  //     '4ae': 'quartae',
  //     '4a': 'quarta',
  //     '4or': 'quattuor',
  //     '4o': 'quarto',
  //     '4us': 'quartus',
  //     '5m': 'quintum',
  //     '5um': 'quintum',
  //     '5am': 'quintam',
  //     '5ae': 'quintae',
  //     '5a': 'quinta',
  //     '5o': 'quinto',
  //     '5us': 'quintus',
  //     '6m': 'sextum',
  //     '6um': 'sextum',
  //     '6am': 'sextam',
  //     '6ae': 'sextae',
  //     '6a': 'sexta',
  //     '6o': 'sexto',
  //     '6us': 'sextus',
  //     '7m': 'septimum',
  //     '7um': 'septimum',
  //     '7am': 'septimam',
  //     '7ae': 'septimae',
  //     '7a': 'septima',
  //     '7o': 'septimo',
  //     '7us': 'septimus',
  //     '8m': 'octavum',
  //     '8um': 'octavum',
  //     '8am': 'octavam',
  //     '8ae': 'octavae',
  //     '8a': 'octava',
  //     '8o': 'octavo',
  //     '8us': 'octavus',
  //     '9m': 'nonum',
  //     '9um': 'nonum',
  //     '9am': 'nonam',
  //     '9ae': 'nonae',
  //     '9a': 'nona',
  //     '9o': 'nono',
  //     '9us': 'nonus'
      

  //   };
    
    

  //   // Function to replace all occurrences based on the replacementsSecund object
  //   const replaceNumberTerms = (punctuationless) => {
  //     const regex = new RegExp(Object.keys(replacementsSecund).join('|'), 'g');
  //     return punctuationless.replace(regex, (match) => replacementsSecund[match]);
  //   }

  //   if (replacements){
  //     //convert v->u, ae->e, oe-e>
      
  //     punctuationless = replaceNumberTerms(punctuationless);
  //     punctuationless = punctuationless.replace(/v/g, "u");
  //     punctuationless = punctuationless.replace(/ae/g, "e");
  //     punctuationless = punctuationless.replace(/oe/g, "e");
  //     punctuationless = punctuationless.replace(/oe/g, "e");
  //     punctuationless = punctuationless.replace(/y/g, "i");
  //     punctuationless = punctuationless.replace(/j/g, "i");
  //     punctuationless = punctuationless.replace(/inm/g, "imm");
  //     punctuationless = punctuationless.replace(/sicud/g, "sicut");
  //     //remove space
  //     punctuationless = punctuationless.replace(/\s{2,}/g," ");
  //   }
    


  //   return punctuationless.toLowerCase()
  // }
  const  checkVariantStatus = (table, ix) => {
    const segmentArray = table[ix].map((i)=> {
      return i.join(" ").trimRight().toLowerCase();
    })
    const invariant = dedupe(segmentArray).length == 1 //true or false
    return invariant
  }
  // see https://js-algorithms.tutorialhorizon.com/2016/01/25/dedupe-an-array-javascript/
  const dedupe = (items) => {
      
    var result = [];
    items.forEach(function(element) {
      if (result.indexOf(element) === -1) {
        result.push(element);
      }
    });
    return result;
  }

  //create display objects from collateX data
  const createDisplayObjects = () => {
    const blockId = props.expressionid
    const d2 = undefined
    const checkList = d2 ? d2[blockId] ? d2[blockId].segments : [] : []
    let variantNumberSkips = 0;
    const displayObjectsArray = []

    //initiateChosenTextIndex and then set in following loop when witness title == "critical"
    let chosenTextIndex;
    collateXData && collateXData.witnesses.forEach((w, ix) => {
      if (w === props.manifestationid?.split("/resource/")){
      //if (w === "cod-pu6y7d"){
        chosenTextIndex = ix
      }
      //$("#wit").append("<th>" + w  + "</th>");
    })
    collateXData && collateXData.table.forEach((seg, ix) => {
      //calculate if segment is status variant or invariant
      const variantStatus = checkVariantStatus(collateXData.table, ix)
      const variantClass = variantStatus ? "invariant" : "variant"
      let status = "unknown"
      let reasons;
      if (variantStatus){
        status = "invariant"
        variantNumberSkips++;
      }
      else{
      // get checkList status for segment
        status = checkList ? checkList[ix-variantNumberSkips] ? checkList[ix-variantNumberSkips].status :"unknown" : "unknown"
        reasons = checkList ? checkList[ix-variantNumberSkips] ? checkList[ix-variantNumberSkips].reasons : "" : ""
      }
      let reasonLinks = ""
      if (reasons){
        reasonLinks = reasons.map((r) => {
          const description = d2.principles[r]
          return "<span class='reason' title='" + description + "'>" + r + "</span>";
        })
        reasonLinks = reasonLinks && reasonLinks.join(" ");
      }

      const segsArray: any[] = []
      const segCount: any[] = []
      
      seg.forEach((i, ix2) => {
        const currentWit = collateXData.witnesses[ix2]
          const expressionIdOfCurrentWit = "http://scta.info/resource/" + currentWit.split("/")[0]
        if (ix > 0){
          //const prevLength = seg[ix2].length
          // conditional here creates a starting offset if an expressionWordRange exists; otherwise the count starts at 0
          

          let prevLength =  expressionIdsWordRangeMap[expressionIdOfCurrentWit] ? parseInt(expressionIdsWordRangeMap[expressionIdOfCurrentWit].split("-")[0]) : 0
          collateXData.table.forEach((seg2, ix3) => {
            if (ix3 < ix){
              prevLength = prevLength + seg2[ix2].length
            }
          })
          const newStart = prevLength + 1
          const count = {start: newStart, end: i.length + prevLength}
          segCount.push(count)
        }
        else{
          // conditional here creates a starting offset if an expressionWordRange exists; otherwise the count starts at 1
          const start = expressionIdsWordRangeMap[expressionIdOfCurrentWit] ? parseInt(expressionIdsWordRangeMap[expressionIdOfCurrentWit].split("-")[0]) : 1
          // conditional here creates a starting offset if an expressionWordRange exists; otherwise the end count is the length of the current segment
          const end = expressionIdsWordRangeMap[expressionIdOfCurrentWit] ? parseInt(expressionIdsWordRangeMap[expressionIdOfCurrentWit].split("-")[0]) + (i.length) : i.length
          const count = {start: start, end: end}
          segCount.push(count)
        }

        // if seg is variant (not invariant) and does match chosenText, set chosen status to "chosen" otherwise set to "unchosen"
        const chosenStatus = (!variantStatus && seg[chosenTextIndex] && seg[chosenTextIndex].join(" ").toLowerCase() === i.join(" ").toLowerCase()) ? "chosen" : "unchosen"
        const segObject = {
          segText: i,
          segIndex: ix2,
          chosenStatus,
          witness: collateXData.witnesses[ix2],
          segCountStart: segCount[ix2].start,
          segCountEnd: segCount[ix2].end,

        }
        segsArray.push(segObject)
      })
      const displayObject = {
        rowNumber: ix,
        variantStatus,
        variantClass,
        status,
        reasonLinks,
        segsArray,
        segCount
      }
      
      displayObjectsArray.push(displayObject)
    })
    setDisplayObjectsArrayList(displayObjectsArray)
  }

  // BEGIN process to get index positions of text to highlight indicating variant status
  const createVariantIndexList = () => {
    let variantHighlightList = []
    displayObjectsArrayList && displayObjectsArrayList.forEach((o) => {
      if (o.variantClass === "variant"){
        const targetWitness = o.segsArray.find((s) => {
          //TODO: critical should replace by props.focusManifestation
          if (s.witness === props.manifestationid?.split("/resource/")[1]){
            return s
          }
        })
        if (targetWitness){
          const start = targetWitness.segCountStart
          const end = targetWitness.segCountEnd
          const wordRangeObject = {
            start: start,
            end: end
          }
          const newObject = {
            text: targetWitness.segText,
            wordRange: wordRangeObject,
            selectedElementTargetId: props.expressionid?.split("/resource/")[1],
            isRelatedTo: "",
            type: "variant",
          }
          

          variantHighlightList.push(newObject)
      }
      }

    })
    //send variantHighlightList to parent component
    props.handleSetVariantIndexList && props.handleSetVariantIndexList(variantHighlightList)
    
  }
  // END process to get index positions of text to highlight indicating variant status

  const displayTable = () => {
    
    return (
          <table>
            <thead>

              <tr id="wit">
                <th key="seg">seg</th>
                {/* <th key="checklist">checklist</th> */}
                {/* <th key="reason">reason</th> */}
              {
                collateXData && collateXData.witnesses.map((w, idx) => {
                  // TODO clean up string matching here; we shouldn't need to do this much string splitting
                  return (<th key={w} title={`${w}: ${witTitles[w]}`}>{idx + 1} <span onClick={()=> {setExcludeList([...excludeList,"/" + w + "/transcription"])}}><FaWindowClose/></span></th>)
                })
              }
              </tr>
            </thead>
            <tbody>
            {displayObjectsArrayList && displayObjectsArrayList.map((r,) => {
            return (
            
              <tr key={"row-" + r.rowNumber} id={"row-" + r.rowNumber} className={"textRow " + r.variantClass}>
                <td key={r.rowNumber + 1}>{r.rowNumber + 1}</td>
                {/* <td key={r.rowNumber + "-" + r.status}>{r.status}</td> */}
                {/* <td key={r.rowNumber + "reasons"}>{r.reasonLinks}</td> */}
                {
                  r.segsArray.map((s) => {
                    return(
                    <td key={r.rowNumber + s.segIndex} onClick={
                      (e) => {
                        setImagesFound(false)
                        setFocusImage({mid: "http://scta.info/resource/" + s.witness, startWord: r.segCount[s.segIndex].start, endWord: r.segCount[s.segIndex].end});
                        const x = e.pageX + 500 < e.view.innerWidth ? e.pageX : e.view.innerWidth - 500
                        const y = e.clientY + 20
                        setImageCoordinates({x: x, y: y})
                        handleSetCitationInfo(s) 
                        props.handleOnSegClick && props.handleOnSegClick("http://scta.info/resource/" + s.witness + "@" + r.segCount[s.segIndex].start + "-" + r.segCount[s.segIndex].end)
                      }}
                      onDoubleClick={() => { 
                        props.handleOnSegDoubleClick && props.handleOnSegDoubleClick("http://scta.info/resource/" + s.witness + "@" + r.segCount[s.segIndex].start + "-" + r.segCount[s.segIndex].end)
                      }}
                      className={s.chosenStatus + " seg"}>
                      {s.segText}
                    </td>
                    )
                  })
                  

                }
              </tr>
              
            )
          })
        }
        </tbody>
      </table>      
    )
    
  }

    return (
        <div className="tableWrapper" style={{position: "relative", "paddingBottom": "250px"}}>
        <div>
          {excludeList.map((e) => {
            return <span onClick={() => {setExcludeList(excludeList.filter(val => val !== e))}}key={e}>X-{e}</span>
          })
        }
        </div>
        {displayTable()}
        
        {collateXData && collateXData.witnesses.map((w, ix) => {
          return <p key={"title" + w} className="witTitle" style={{fontSize: "12px", margin: "2px"}}>{ix + 1}: {witTitles[w].split(" in ")[1]}</p>
        }
        )}
        {focusImage && 
        <div className="imageViewWrapper" style={imageCoordinates ? {display: "block", position: "fixed", left: imageCoordinates.x + "px", top: imageCoordinates.y + "px", "maxWidth": "500px"} : {display: "none"}}>
          
          {/* <Tooltip clickable={true} place="bottom"> */}
        {citationInfo && 
        <ToolTipContent 
          handleChangeInfo={props.handleOnSegDoubleClick} 
          id={citationInfo.tresourceid} 
          info={{focusInfo: {mtFocus: "", docSource: citationInfo.tresourceid, expressionid: citationInfo.tresourceid}}} 
          selectedTextRange={citationInfo.selectionRange.wordRange} 
          selectedText={citationInfo.selectionRange.text}/>
        }

          <div className="imageCloseBar" onClick={()=> setImageCoordinates(null)} title="click to close"><FaRegWindowClose/></div>
          {/* </Tooltip> */}


          {/* <Surface3 manifestationid={focusImage.mid} startWord={focusImage.startWord} endWord={focusImage.endWord} handleImagesFound={setImagesFound} />
          <div className="imageCloseBar" onClick={()=> setImageCoordinates()} title="click to close"><FaRegWindowClose/></div>
          {citationInfo && 
          <div style={{"padding": "10px", "fontSize": "12px"}}><Citation tresourceid={citationInfo.tresourceid} citationStyle="minimal" showGitHubEdit="true" selectionRange={citationInfo.selectionRange}/></div>} */}
        
        </div>
        }
        </div>
    )
  }